@if (meeting.isMinutesRegenerationInFlight) {
  @let progress = meeting.minutesGenerationProgress ?? 0;
  <div class="centered-content">
    <app-progress-loader class="minutes-progress" [value]="progress" loading></app-progress-loader>
    @if (meeting.minutesGenerationTemplateProgress; as templateProgress) {
      <span class="loading-text">{{
        'MEETINGS.MINUTES_TEMPLATE_ITEM_PROGRESS_WITH_PERCENTAGE'
          | translate: { level: templateProgress.level, index: templateProgress.index, total: templateProgress.total, progress }
      }}</span>
    } @else {
      <span class="loading-text">{{ 'MEETINGS.MINUTES_PROCESSING_MESSAGE' | translate }} ({{ progress }}%)</span>
    }
  </div>
} @else {
  <div class="centered-content">
    <div class="notice">
      <mat-icon fontSet="material-symbols-outlined" class="notice-icon">restart_alt</mat-icon>
      <h1>{{ 'EDITOR.LEGACY_MINUTES.TITLE' | translate }}</h1>
      <p>{{ 'EDITOR.LEGACY_MINUTES.EXPLANATION' | translate }}</p>
      <p class="contact">{{ 'EDITOR.LEGACY_MINUTES.CONTACT_SUPPORT' | translate }}</p>
      @if (canUserEdit) {
        <button mat-raised-button [disabled]="(isRegenerationPending$ | async) ?? false" (click)="regenerate()">
          {{ 'EDITOR.LEGACY_MINUTES.REGENERATE' | translate }}
        </button>
      }
    </div>
  </div>
}
